import { useEffect, useState } from 'react';

export const ACTION_MESSAGES = {
  AGENCIES: {
    TRIGGER: {
      SAVE: {
        type: 'success',
        message: 'Trigger saved successfully'
      },
      DELETE: {
        type: 'success',
        message: 'Trigger deleted successfully'
      }
    },
    LEAD: {
      ARCHIVE: is_archived => ({
        type: 'success',
        message: `Lead ${is_archived ? 'archived' : 'unarchived'} successfully`
      }),
      ARCHIVE_ERROR: error => ({
        type: 'success',
        message: 'Oops! Something went wrong',
        details: error
      })
    }
  },
  MOBILE_APPS: {
    UPDATE: {
      type: 'success',
      message: 'Mobile App updated successfully'
    },
    UPDATE_ERROR: {
      type: 'error',
      message: 'There was an error saving the Mobile App'
    },
    BUILD_CREDENTIALS: {
      SAVE: {
        type: 'success',
        message: 'Build Credentials saved successfully'
      },
      DELETE: {
        type: 'success',
        message: 'Build Credentials deleted successfully'
      }
    },
    BUILD: {
      SAVE: {
        type: 'success',
        message: 'Build configuration saved successfully'
      }
    }
  },
  BASE: {
    STRIPE: {
      NO_STRIPE_ACCOUNT: {
        type: 'info',
        message: 'No Stripe account found for Agency.'
      },
      NO_PAYMENT_METHOD: {
        type: 'info',
        message: 'No payment method found.'
      },
      LAST_CHARGE_FAILED: {
        type: 'info',
        message:
          'The latest charge for this Agency failed or the latest invoice in Stripe is past due.'
      }
    }
  },
  DEFAULT_SUCCESS: message => ({
    type: 'success',
    message
  }),
  DEFAULT_ERROR: message => ({
    type: 'error',
    message
  }),
  DEFAULT_ERROR_WITH_DETAILS: details => ({
    type: 'error',
    message: 'Oops! Something went wrong',
    details
  }),
  DEFAULT_INFO: message => ({
    type: 'info',
    message
  }),
  NULL_MESSAGE: {
    type: null,
    message: ''
  }
};

export const useNotification = ({ type, message }) => {
  const [notification, setNotification] = useState({
    type,
    message
  });

  useEffect(() => {
    if (notification.message === '' || notification.type === null) {
      return () => {};
    }

    const messageTimer = setTimeout(() => {
      setNotification({ type: null, message: '' });
    }, 10000);

    return () => clearTimeout(messageTimer);
  }, [notification]);

  return {
    notification,
    setNotification
  };
};
